import type { FC } from 'react';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import StickyLayout from 'components/layout/StickyLayout';
import { CreativeExpansionProvider } from '../../features/creatives/contexts/CreativeExpantionContext';
import CreativesFbAds from '../../features/ad-lib-creatives/components/CreativesFbAds';
import DataLoadTimestamp from '../../features/ad-lib-creatives/components/DataLoadTimestamp';

const CreativesFbAdsPage: FC = () => (
  <>
    <StickyLayout
      id="creatives-ads-page"
      pageTitle="Creatives"
      titleAdornment={
        <Suspense fallback={null}>
          <DataLoadTimestamp />
        </Suspense>
      }
    >
      <CreativeExpansionProvider>
        <CreativesFbAds />
      </CreativeExpansionProvider>
    </StickyLayout>
    <Outlet />
  </>
);

export default CreativesFbAdsPage;
